import { LocationOn } from "@mui/icons-material";
import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Container, Grid2, Paper, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router";


export default function Home() {
    const navigate = useNavigate();
    
    return (
        <Container>
            <Card sx={{ textAlign: "center", background: "#FEF9F8", marginX: "auto", width: "100%", boxShadow: "none", marginTop:{ xs: 10, sm: 10, md: 10}}}>
                <CardMedia sx={{ height: { xs:300, sm:550, md:550, lg:650 }, marginBottom: 3 }} image="home-banner.jpg" />
            </Card>
            <Button variant="contained" sx={{ background: "#d32f2f", width:'100%', display:{ xs: 'block', sm: 'block', md: 'none' }, marginBottom: 4}} onClick={() => navigate("/order-now-step1")} size="large">GUSTO KO MAGPADELIVER</Button>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Card sx={{ size: { lg: 4 } }}>
                        <CardContent sx={{ height: '100%' }}>
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                                LPG DELIVERY
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Enjoy free delivery and installation of LPG for most part of Quezon City, Marikina, and San Mateo.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Card sx={{ size: { lg: 4 } }}>
                        <CardContent sx={{ height: '100%' }}>
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                                BIG DISCOUNTS
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                We offer big and exclusive discounts for high volume customers.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>

                    <Card sx={{ size: { lg: 4 } }}>
                        <CardContent sx={{ height: '100%' }}>
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                                RICE DELIVERY
                            </Typography>
                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                Enjoy free delivery of fresh and affordable rice right at your doorstep.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid2>
            </Grid2>
            <Box sx={{ bgcolor: 'background.default', py: 8 }}>
                <Container maxWidth="lg">
                    <Grid2 container spacing={4} alignItems="center">
                        <Grid2 size={{ xs: 12, md: 8, lg: 8 }}>
                            <Typography
                                variant="h4"
                                component="h1"
                                gutterBottom
                                sx={{ color: 'error.main' }}
                            >
                                Start Earning Today
                            </Typography>
                            <Typography
                                variant="body1"
                                paragraph
                                sx={{ mb: 4, color: 'text.secondary' }}
                            >
                                Sari-sari store ka ba? Become our marketing partner! If you are a business owner who wants to earn extra income, you can join our merchant partnership program and earn commissions by promoting our products. We provide all the necessary tools and support to help you succeed in your affiliate marketing journey.
                                Contact us now and start earning today!
                            </Typography>
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
                            <Box
                                component="img"
                                src="affiliate-marketing-illustration.jpg"
                                alt="Affiliate Marketing"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                }}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 12, lg: 12 }} sx={{ display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
                            <Button
                                variant="contained"
                                color="error"
                                size="large"
                                href="contact-us?inquiry=How to become an affiliate marketing partner?"
                                sx={{ px: 4, py: 1.5 }}>
                                Contact Us
                            </Button>
                        </Grid2>
                    </Grid2>
                </Container>
            </Box>

        </Container>
    );
}